// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "desktop-" + {"29":"mediaelement","402":"searchAutoCompleteDesktop","533":"searchAutoCompleteDesktop2","588":"magnific-popup"}[chunkId] + "-bundle.js";
};